const dataLayer = window.dataLayer || [];

const gtmEvents = {
  deviceDeleteInstallation: 'deviceDeleteInstallation',
};

const DevicesDeactivateModalModalController = (
  $scope,
  $uibModalInstance,
  installation,
  $state,
  installationsService,
  gettextCatalog,
) => {
  'ngInject';

  $scope.installation = installation;
  $scope.deleting = false;

  const handleError = (error) => {
    let errorMsg = gettextCatalog.getString('An error occurred while deactivating the device.');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg = `${
          error.data.message
        } ${error.status.toString()} - ${error.statusText.toString()}`;
      } else {
        errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
      }
    } else {
      errorMsg += `. ${gettextCatalog.getString('Please try again later')}.`;
    }
    $scope.errorFlag = true;
    $scope.errorText = errorMsg;
    $scope.deleting = false;
  };

  $scope.ok = () => {
    $scope.deleting = true;

    dataLayer.push({
      event: gtmEvents.deviceDeleteInstallation,
      data: {
        equipment: $scope.installation.id,
      },
    });

    installationsService.deleteInstallation($scope.installation.id).then(() => {
      $scope.$emit('deviceDeactivated');
      $uibModalInstance.dismiss();
      $state.go('devices2.base');
    }, handleError);
  };

  $scope.cancel = () => {
    $uibModalInstance.dismiss('cancel');
  };
};

export default DevicesDeactivateModalModalController;
